import range from 'lodash/range';
import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const StyledContentLoader = styled(ContentLoader)`
  aspect-ratio: 178/256;
  border-radius: var(--size-border-radius-md);
  height: 100%;
`;

const Product = ({ width = '100%' }) => (
  <StyledContentLoader viewBox="0 0 178 256" style={{ minWidth: width }}>
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="188" />
    <rect x="0" y="196" rx="2" ry="2" width="162" height="28" />
    <rect x="0" y="230" rx="2" ry="2" width="100" height="20" />
  </StyledContentLoader>
);

const ProductLoader = ({ count = 12, width }) =>
  range(count).map(item => <Product width={width} key={item} />);

export default ProductLoader;
